import { createContext, useContext } from 'react';

import { PassengerBookingView } from '@mopla/data-models';

export interface IBookingCancellationContext {
	cancelBooking(bookedTicket: PassengerBookingView): void;
}

const bookingCancellationContext = createContext(
	{} as IBookingCancellationContext
);

export const BookingCancellationContextProvider =
	bookingCancellationContext.Provider;

export const useBookingCancellation = () =>
	useContext(bookingCancellationContext);
